<template> 
<div>
  <div class="or-cookie__banner" v-if="tstringsReady">
    <div class="or-cookie__text">{{tstrings.KOKUAPP.COOKIE_MSG}} <a :href="cookieLink">{{tstrings.KOKUAPP.COOKIE_PAGE_LINK_TEXT}}</a></div>
    <div class="or-cookie__buttons">
      <button class="or-cookie__button" v-on:click="approve">{{tstrings.KOKUAPP.AGREE}}</button>
      <button class="or-cookie__button" v-on:click="toggleSettings">{{tstrings.KOKUAPP.COOKIE_SETTINGS}}</button>
    </div>
  </div>
</div>
</template>

<script>
import cookieShared from './cookie-shared.js'
import constants from '../../lib/constants.js'

const { WEB_COOKIE_PAGE_LINK } = constants()

export default {
  name: 'cookie-banner',

  mixins: [cookieShared],

  data () {
    return {
      tstrings: {},
      tstringsReady: false,
      cookieLink: WEB_COOKIE_PAGE_LINK
    }
  },

  events: {
    'language-set' (obj) {
      this.tstrings = obj
      this.tstringsReady = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// cookie-banner.vue?0e6c5915